<template>
	<li :class="menuItem.class ? menuItem.class : itemClass" class="mobile-menu-item">
		<component
			:is="tagName"
			:href="tagName === 'a' ? menuItem.url : null"
			class="mobile-menu-item__link"
			:class="`mobile-menu-item--${menuItem.id}`"
			:aria-label="tagName === 'button' ? `Open ${menuItem.name} sub-categories` : undefined"
			:data-menu-link="menuItem.linkType ? menuItem.linkType : undefined"
		>
			<div class="left-section flex">
				<span>
					{{ menuItem.name }}
				</span>
			</div>
			<div class="right-section flex-row align-items-start">
				<span v-if="menuItem.secondaryText" class="fs-13 mr-tiny medium-bold">
					{{ menuItem.secondaryText }}
				</span>
				<span v-if="tagName === 'button'" class="icon right-icon icon-chevron-right icon-small" aria-hidden="true"></span>
			</div>
		</component>
	</li>
</template>

<script>
export default {
	name: 'MobileMenuItem',
	props: {
		menuItem: {
			type: Object,
			required: true
		},
		itemClass: {
			type: String,
			default: 'secondary'
		}
	},
	computed: {
		tagName() {
			return this.menuItem.url && !this.hasChildren ? 'a' : 'button';
		},
		hasChildren() {
			return (this.menuItem.children?.length ?? 0) > 0;
		},
	}
};
</script>

<style lang='less' scoped>
@import '~@less/_mixins.less';

.mobile-menu-item {
	width: 100%;

	&__link {
		.button-reset();
		
		text-align: left;
		width: 100%;
		align-items: center;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		cursor: pointer;
		color: shade(@CL, 80%);
		text-decoration: none;
		line-height: 19px;
		font-size: inherit;
		font-weight: inherit;
	}

	.right-section {
		font-size: 10px;
		span {
			color: @BB;
		}
	}
	.left-section {
		flex: 1;
	}
	&.primary {
		border-bottom: none;
		background: white;
		padding: 8px 10px;
		font-size: 1rem;
		font-weight: 500;
	}
	&.secondary {
		border-bottom: none;
		background: white;
		padding: 6px 10px;
		font-size: 0.875rem;
		font-weight: 400;
	}
	&__red {
		.left-section {
			span {
				color: @BR;
			}
		}
	}
}
</style>